import { render, staticRenderFns } from "./AddTransferOrder.vue?vue&type=template&id=dd88acfc&"
import script from "./AddTransferOrder.vue?vue&type=script&lang=js&"
export * from "./AddTransferOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports